import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-md-8 col-8" }
const _hoisted_6 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_7 = { "aria-label": "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb mb-0" }
const _hoisted_9 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_10 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_11 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_12 = { class: "col-md-4 col-4" }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "title mb-0" }
const _hoisted_17 = { class: "d-flex border-top border-bottom justify-content-betweend-flex border-top border-bottom justify-content-between my-2 py-2" }
const _hoisted_18 = { class: "flex-grow-1 pr-2" }
const _hoisted_19 = { class: "flex-shrink-0" }
const _hoisted_20 = { class: "soft-yellow-badge" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-2 col-sm-2 col-5" }
const _hoisted_23 = { class: "col-lg-10 col-sm-10 col-7" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-lg-2 col-sm-2 col-5" }
const _hoisted_26 = { class: "col-lg-10 col-sm-10 col-7" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-lg-2 col-sm-2 col-5" }
const _hoisted_29 = { class: "to-upper" }
const _hoisted_30 = { class: "col-lg-10 col-sm-10 col-7" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-lg-2 col-sm-2 col-5" }
const _hoisted_33 = { class: "col-lg-10 col-sm-10 col-7" }
const _hoisted_34 = { class: "text-center my-2 text-md-right" }
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_36 = { class: "table-responsive my-3 font-12" }
const _hoisted_37 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_38 = { class: "table-primary nowrap-text" }
const _hoisted_39 = { scope: "col" }
const _hoisted_40 = {
  key: 0,
  scope: "col"
}
const _hoisted_41 = {
  key: 1,
  scope: "col"
}
const _hoisted_42 = {
  key: 2,
  scope: "col"
}
const _hoisted_43 = {
  key: 3,
  scope: "col"
}
const _hoisted_44 = {
  key: 4,
  scope: "col"
}
const _hoisted_45 = {
  key: 5,
  scope: "col"
}
const _hoisted_46 = {
  key: 6,
  scope: "col"
}
const _hoisted_47 = {
  key: 7,
  scope: "col"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "desc-wrap" }
const _hoisted_52 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_53 = { key: 2 }
const _hoisted_54 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_55 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_56 = {
  key: 5,
  class: "text-nowrap"
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 2 }
const _hoisted_60 = {
  key: 6,
  class: "text-nowrap"
}
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = {
  key: 7,
  class: "text-nowrap"
}
const _hoisted_64 = { key: 0 }
const _hoisted_65 = {
  key: 1,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_66 = {
  key: 0,
  class: "company-logo-wrap border p-1 rounded my-3 bg-white"
}
const _hoisted_67 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_68 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_69 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_70 = {
  class: "nav-link active",
  id: "Contract-tab",
  "data-toggle": "tab",
  "data-target": "#Contract",
  type: "button",
  role: "tab",
  "aria-controls": "Contract",
  "aria-selected": "true"
}
const _hoisted_71 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_72 = {
  class: "nav-link",
  id: "Contract1-tab",
  "data-toggle": "tab",
  "data-target": "#Contract1",
  type: "button",
  role: "tab",
  "aria-controls": "Contract1",
  "aria-selected": "false"
}
const _hoisted_73 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_74 = {
  class: "tab-pane fade show active",
  id: "Contract",
  role: "tabpanel",
  "aria-labelledby": "Contract-tab"
}
const _hoisted_75 = {
  class: "tab-pane fade",
  id: "Contract1",
  role: "tabpanel",
  "aria-labelledby": "Contract1-tab"
}
const _hoisted_76 = {
  key: 2,
  class: "form-wrap mt-2"
}
const _hoisted_77 = { class: "form-group" }
const _hoisted_78 = { class: "mb-0" }
const _hoisted_79 = { class: "inline-items mt-3" }
const _hoisted_80 = { class: "mb-2" }
const _hoisted_81 = { class: "mr-3" }
const _hoisted_82 = { class: "signature-wrap mb-2" }
const _hoisted_83 = { class: "signature-wrap mb-2" }
const _hoisted_84 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_85 = { for: "" }
const _hoisted_86 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_87 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_88 = { class: "form-group" }
const _hoisted_89 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_90 = { class: "form-group" }
const _hoisted_91 = { class: "inline-items" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { class: "upload-btn-wrapper" }
const _hoisted_94 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_95 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eraser" }, null, -1)
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { class: "upload-btn-wrapper" }
const _hoisted_99 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_100 = {
  key: 3,
  class: "form-wrap mt-2"
}
const _hoisted_101 = { class: "form-group" }
const _hoisted_102 = { class: "mb-0" }
const _hoisted_103 = { class: "row align-items-center" }
const _hoisted_104 = /*#__PURE__*/_createVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createVNode("div", { class: "form-group" })
], -1)
const _hoisted_105 = { class: "col-sm-6 text-sm-end" }
const _hoisted_106 = { class: "form-group" }
const _hoisted_107 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments mr-2" }, null, -1)
const _hoisted_108 = { class: "modal-body" }
const _hoisted_109 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-home" })
], -1)
const _hoisted_110 = { class: "modal-wrap default-modal" }
const _hoisted_111 = {
  class: "modal fade",
  id: "declineInvite",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_112 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_113 = { class: "modal-content" }
const _hoisted_114 = { class: "modal-header" }
const _hoisted_115 = {
  class: "modal-title",
  id: "deleteModalLabel"
}
const _hoisted_116 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_117 = { class: "modal-body" }
const _hoisted_118 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_119 = { class: "form-group" }
const _hoisted_120 = { for: "exampleInputEmail1" }
const _hoisted_121 = { class: "modal-footer" }
const _hoisted_122 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_123 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_124 = { class: "ml-2" }
const _hoisted_125 = {
  key: 1,
  class: "ml-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_SignaturePadModal = _resolveComponent("SignaturePadModal")
  const _component_SignatureUploadModal = _resolveComponent("SignatureUploadModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.state.ui.isLoading.getItemList || _ctx.state.ui.isPostLoading.acceptJobEstimationInvitation || _ctx.state.ui.isPostLoading.declineInvitation)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("nav", _hoisted_7, [
                _createVNode("ol", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("li", _hoisted_10, [
                    _createVNode("a", _hoisted_11, _toDisplayString(_ctx.$t('estimation_preview')), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn outline d-inline-block",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoListJobEstimation && _ctx.gotoListJobEstimation(...args)))
              }, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode("h1", _hoisted_16, _toDisplayString(_ctx.$t('job_estimation_acknowledgement_request_for')) + " \"" + _toDisplayString(_ctx.state.sendData.title) + "\" " + _toDisplayString(_ctx.$t('estimation_of')) + " \"" + _toDisplayString(_ctx.state.projectName) + "\" " + _toDisplayString(_ctx.$t('project')), 1),
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('estimation_no')) + ". " + _toDisplayString(_ctx.state.sendData.no), 1)
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('awaiting_customer')), 1)
          ])
        ]),
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.ui.errors.errorList.acceptJobEstimationInvitation,
          hasError: _ctx.state.ui.errors.hasError
        }, null, 8, ["errors", "hasError"]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1)
            ])
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode("p", null, _toDisplayString(_ctx.state.selectedDate), 1)
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('prepared_by')) + ":", 1)
            ])
          ]),
          _createVNode("div", _hoisted_26, [
            _createVNode("p", null, _toDisplayString((_ctx.state.prepared_by) ? _ctx.state.prepared_by.full_name : ""), 1)
          ])
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode("p", null, [
              _createVNode("strong", _hoisted_29, _toDisplayString(_ctx.$t('customer')) + ":", 1)
            ])
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("p", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedCustomers, (customer, customerIndex) => {
                return (_openBlock(), _createBlock("span", { key: customerIndex }, _toDisplayString((customer.name) ? customer.name + " (" + customer.email + ")" :
                            customer.email) + " ,", 1))
              }), 128))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_31, [
          _createVNode("div", _hoisted_32, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('total')) + ":", 1)
            ])
          ]),
          _createVNode("div", _hoisted_33, [
            _createVNode("p", null, _toDisplayString(_ctx.totalCost), 1)
          ])
        ]),
        _createVNode("div", _hoisted_34, [
          _createVNode("a", {
            href: _ctx.state.pdf_link,
            class: "btn default-btn mr-2 d-inline-block",
            target: "_blank"
          }, [
            _hoisted_35,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('download_itemized_estimate')), 1)
          ], 8, ["href"])
        ]),
        _createVNode("p", null, [
          _createVNode("strong", null, _toDisplayString(_ctx.$t('itemized_estimate')) + ":", 1)
        ]),
        _createVNode("div", _hoisted_36, [
          _createVNode("table", _hoisted_37, [
            _createVNode("thead", _hoisted_38, [
              _createVNode("tr", null, [
                _createVNode("th", _hoisted_39, _toDisplayString(_ctx.$t('item')), 1),
                (_ctx.state.fields.description == 1)
                  ? (_openBlock(), _createBlock("th", _hoisted_40, _toDisplayString(_ctx.$t('description')), 1))
                  : _createCommentVNode("", true),
                (_ctx.state.fields.unit == 1)
                  ? (_openBlock(), _createBlock("th", _hoisted_41, _toDisplayString(_ctx.$t('unit')), 1))
                  : _createCommentVNode("", true),
                (_ctx.state.fields.quantity == 1)
                  ? (_openBlock(), _createBlock("th", _hoisted_42, _toDisplayString(_ctx.$t('qty')), 1))
                  : _createCommentVNode("", true),
                (_ctx.state.fields.cost == 1)
                  ? (_openBlock(), _createBlock("th", _hoisted_43, _toDisplayString(_ctx.$t('cost')), 1))
                  : _createCommentVNode("", true),
                (_ctx.state.fields.cost == 1)
                  ? (_openBlock(), _createBlock("th", _hoisted_44, _toDisplayString(_ctx.$t('sub_total')), 1))
                  : _createCommentVNode("", true),
                (_ctx.state.fields.markup == 1)
                  ? (_openBlock(), _createBlock("th", _hoisted_45, _toDisplayString(_ctx.$t('markup')), 1))
                  : _createCommentVNode("", true),
                (_ctx.state.fields.allowance == 1)
                  ? (_openBlock(), _createBlock("th", _hoisted_46, _toDisplayString(_ctx.$t('allowance')), 1))
                  : _createCommentVNode("", true),
                (_ctx.state.fields.total == 1)
                  ? (_openBlock(), _createBlock("th", _hoisted_47, _toDisplayString(_ctx.$t('total')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (item, itemIndex) => {
                return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                  _createVNode("td", null, [
                    (item.item.parent_id)
                      ? (_openBlock(), _createBlock("p", _hoisted_48, _toDisplayString(item.mainitem) + ": " + _toDisplayString(item.name), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_49, _toDisplayString(item.name), 1))
                  ]),
                  (_ctx.state.fields.description == 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_50, [
                        _createVNode("div", _hoisted_51, [
                          _createVNode("p", null, _toDisplayString(item.description), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.fields.unit == 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_52, [
                        _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.fields.quantity == 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_53, [
                        _createVNode("p", null, _toDisplayString(item.quantity), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.fields.cost == 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_54, [
                        _createVNode("p", null, _toDisplayString(item.cost), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.fields.cost == 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_55, [
                        _createVNode("p", null, _toDisplayString(item.cost), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.fields.markup == 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_56, [
                        (item.markup != '0.00' && item.markup_type == 1)
                          ? (_openBlock(), _createBlock("p", _hoisted_57, _toDisplayString(item.markup), 1))
                          : _createCommentVNode("", true),
                        (item.markup != '0.00' && item.markup_type != 1)
                          ? (_openBlock(), _createBlock("p", _hoisted_58, _toDisplayString(item.markup), 1))
                          : _createCommentVNode("", true),
                        (item.markup === '0.00')
                          ? (_openBlock(), _createBlock("p", _hoisted_59, "-"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.fields.allowance == 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_60, [
                        (item.allowance != '$0.00')
                          ? (_openBlock(), _createBlock("p", _hoisted_61, _toDisplayString(item.allowance), 1))
                          : (_openBlock(), _createBlock("p", _hoisted_62, "-"))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.fields.total == 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_63, [
                        _createVNode("p", null, _toDisplayString(item.total), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createVNode("tr", null, [
                _createVNode("td", {
                  colspan: _ctx.totalTd - 1
                }, null, 8, ["colspan"]),
                _createVNode("td", null, _toDisplayString(_ctx.$t('total')), 1),
                _createVNode("td", null, [
                  _createVNode("p", null, _toDisplayString(_ctx.totalCost), 1)
                ])
              ])
            ])
          ])
        ]),
        ((_ctx.state.sendData.acknowledgement && _ctx.state.sendData.legal_statement && _ctx.state.sendData.logo) ||
                (_ctx.state.sendData.company && _ctx.state.sendData.company.acknowledgement &&
                    _ctx.state.sendData.company.legal_statement && _ctx.state.sendData.company.logo))
          ? (_openBlock(), _createBlock("p", _hoisted_64, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')), 1)
            ]))
          : _createCommentVNode("", true),
        ((_ctx.state.sendData.acknowledgement && _ctx.state.sendData.legal_statement && _ctx.state.sendData.logo) ||
                (_ctx.state.sendData.company && _ctx.state.sendData.company.acknowledgement &&
                    _ctx.state.sendData.company.legal_statement && _ctx.state.sendData.company.logo))
          ? (_openBlock(), _createBlock("div", _hoisted_65, [
              (_ctx.state.sendData.logo || _ctx.state.sendData.company?.logo)
                ? (_openBlock(), _createBlock("div", _hoisted_66, [
                    (_ctx.state.sendData.logo)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          class: "rounded",
                          src: _ctx.state.sendData.logo,
                          alt: ""
                        }, null, 8, ["src"]))
                      : (_ctx.state.sendData.company?.logo)
                        ? (_openBlock(), _createBlock("img", {
                            key: 1,
                            class: "rounded",
                            src: _ctx.state.sendData.company.logo,
                            alt: ""
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_67, [
                _createVNode("ul", _hoisted_68, [
                  _createVNode("li", _hoisted_69, [
                    _createVNode("button", _hoisted_70, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                  ]),
                  _createVNode("li", _hoisted_71, [
                    _createVNode("button", _hoisted_72, _toDisplayString(_ctx.$t('legal_statement')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_73, [
                  _createVNode("div", _hoisted_74, [
                    _createVNode("div", {
                      innerHTML: _ctx.state.sendData.acknowledgement || _ctx.state.sendData.company?.acknowledgement
                    }, null, 8, ["innerHTML"])
                  ]),
                  _createVNode("div", _hoisted_75, [
                    _createVNode("div", {
                      innerHTML: _ctx.state.sendData.legal_statement || _ctx.state.sendData.company?.legal_statement
                    }, null, 8, ["innerHTML"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.sendData.note)
          ? (_openBlock(), _createBlock("div", _hoisted_76, [
              _createVNode("div", _hoisted_77, [
                _createVNode("p", _hoisted_78, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('note')) + ": ", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.state.sendData.note), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_79, [
          _createVNode("p", _hoisted_80, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t('senders_signature')), 1)
          ]),
          _createVNode("ul", null, [
            _createVNode("li", _hoisted_81, [
              _createVNode("div", _hoisted_82, [
                _createVNode("img", {
                  src: _ctx.state.sendData.signature,
                  alt: ""
                }, null, 8, ["src"])
              ]),
              _createVNode("p", null, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.state.sendData.signature_date), 1)
              ])
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.singedCustomers, (customer, customerIndex) => {
              return (_openBlock(), _createBlock("li", {
                class: "mr-3",
                key: customerIndex
              }, [
                _createVNode("div", _hoisted_83, [
                  _createVNode("img", {
                    src: customer.signature,
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _createVNode("p", null, [
                  _createVNode("span", null, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('date')), 1),
                    _createTextVNode(" " + _toDisplayString(customer.signaute_date), 1)
                  ])
                ]),
                _createVNode("div", null, _toDisplayString(customer.name ? customer.name : customer.email), 1)
              ]))
            }), 128)),
            (!_ctx.state.ui.isLoading.signaturePadLoad && _ctx.state.data.sendarSignature)
              ? (_openBlock(), _createBlock("li", _hoisted_84, [
                  _createVNode("label", _hoisted_85, [
                    _createTextVNode(_toDisplayString(_ctx.$t('signature')) + " ", 1),
                    _hoisted_86
                  ]),
                  (_ctx.state.data.sendarSignature)
                    ? (_openBlock(), _createBlock("div", _hoisted_87, [
                        _createVNode("img", {
                          src: _ctx.state.data.sendarSignature,
                          alt: ""
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("button", {
                    for: "formFileSm",
                    class: "btn default-btn mr-2",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.enableSignaturPad && _ctx.enableSignaturPad(...args)))
                  }, _toDisplayString(_ctx.$t('add_new_signature')), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("li", null, [
              _createVNode("div", _hoisted_88, [
                _createVNode("div", null, [
                  (_ctx.state.data.cropSignature)
                    ? (_openBlock(), _createBlock("div", _hoisted_89, [
                        _createVNode("img", {
                          src: _ctx.state.data.cropSignature,
                          alt: ""
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_90, [
                _createVNode("div", _hoisted_91, [
                  (_ctx.state.sendData.status !== 2)
                    ? (_openBlock(), _createBlock("ul", _hoisted_92, [
                        _createVNode("li", null, [
                          _createVNode("div", _hoisted_93, [
                            _createVNode("button", _hoisted_94, [
                              _hoisted_95,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_signature')), 1)
                            ]),
                            _createVNode("input", {
                              ref: "signatureInput",
                              type: "file",
                              accept: "image/png, image/jpeg",
                              id: "profileUpdate",
                              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.uploadSignatureFile($event)))
                            }, null, 544)
                          ])
                        ]),
                        _createVNode("li", null, [
                          _createVNode("button", {
                            class: "btn default-btn",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showSignaturePad && _ctx.showSignaturePad(...args)))
                          }, [
                            _hoisted_96,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('draw_signature')), 1)
                          ])
                        ]),
                        (_ctx.state.data.haveProfileSign)
                          ? (_openBlock(), _createBlock("li", _hoisted_97, [
                              _createVNode("div", _hoisted_98, [
                                _createVNode("button", {
                                  for: "formFileSm",
                                  class: "btn default-btn mr-2",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.userSignature('use')))
                                }, [
                                  _hoisted_99,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('use_profile_signature')), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("li", null, [
                          _createVNode("button", {
                            class: "btn red-btn",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearSignature()))
                          }, _toDisplayString(_ctx.$t('clear')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        (_ctx.state.sendData.note)
          ? (_openBlock(), _createBlock("div", _hoisted_100, [
              _createVNode("div", _hoisted_101, [
                _createVNode("p", _hoisted_102, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('note')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.state.sendData.note), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_103, [
          _hoisted_104,
          _createVNode("div", _hoisted_105, [
            _createVNode("div", _hoisted_106, [
              _createVNode("button", {
                class: "btn default-btn outline orange d-inline-block mb-0 mr-2",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.redirectToChat && _ctx.redirectToChat(...args)))
              }, [
                _hoisted_107,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('discussion')), 1)
              ]),
              (_ctx.state.sendData.status !== 2)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("button", {
                      type: "submit",
                      class: "btn default-btn mr-2",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.acceptJobEstimation && _ctx.acceptJobEstimation(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.acceptJobEstimationInvitation ?
                                    'Loading...' : 'Accept'), 1),
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn red-btn d-inline-block",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showDeclineModal && _ctx.showDeclineModal(...args)))
                    }, _toDisplayString(_ctx.$t('decline')), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showSuccesCustomModal)
        ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
            key: 1,
            onClose: _ctx.closeSuccessCustomModal,
            showModal: _ctx.state.data.showSuccesCustomModal,
            titleMessage: _ctx.state.data.successFulMessage,
            isButton: _ctx.state.data.isEstimationAccepted
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_108, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn mr-2 mb-2",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.redirectToDashboard && _ctx.redirectToDashboard(...args)))
                }, [
                  _hoisted_109,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('go_to_dashboard')), 1)
                ]),
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn mr-2 mb-2",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.redirectToEstimationList && _ctx.redirectToEstimationList(...args)))
                }, _toDisplayString(_ctx.$t('go_to_estimation')), 1)
              ])
            ]),
            _: 1
          }, 8, ["onClose", "showModal", "titleMessage", "isButton"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_110, [
        _createVNode("div", _hoisted_111, [
          _createVNode("div", _hoisted_112, [
            _createVNode("div", _hoisted_113, [
              _createVNode("div", _hoisted_114, [
                _createVNode("h5", _hoisted_115, _toDisplayString(_ctx.$t('invitation_decline')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeDecline && _ctx.closeDecline(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_116
                ])
              ]),
              _createVNode("div", _hoisted_117, [
                _createVNode("div", _hoisted_118, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t('decline_invitation_confirmation')) + ".", 1)
                ]),
                _createVNode("div", _hoisted_119, [
                  _createVNode("label", _hoisted_120, _toDisplayString(_ctx.$t('reason_to_decline')), 1),
                  _withDirectives(_createVNode("textarea", {
                    class: _ctx.state.ui.isPostLoading.isResonRequired ? 'form-control error-field' : 'form-control',
                    "aria-describedby": "emailHelp",
                    placeholder: _ctx.$t('provide_reason_for_decline'),
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.data.declineMessage = $event))
                  }, null, 10, ["placeholder"]), [
                    [_vModelText, _ctx.state.data.declineMessage]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_121, [
                _createVNode("button", {
                  class: "btn default-btn outline danger d-inline-block mb-0",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.declineInvitation && _ctx.declineInvitation(...args))),
                  disabled: _ctx.state.ui.isPostLoading.declineInvitation
                                    ? _ctx.state.ui.isPostLoading.declineInvitation
                                    : false
                                    
                }, [
                  (_ctx.state.ui.isPostLoading.declineInvitation === true)
                    ? (_openBlock(), _createBlock("span", _hoisted_122, [
                        _hoisted_123,
                        _createVNode("span", _hoisted_124, _toDisplayString(_ctx.$t('loading1')), 1)
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_125, _toDisplayString(_ctx.$t('decline')), 1))
                ], 8, ["disabled"]),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeDecline && _ctx.closeDecline(...args)))
                }, _toDisplayString(_ctx.$t('no')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSignaturePad)
      ? (_openBlock(), _createBlock(_component_SignaturePadModal, {
          key: 0,
          onClose: _ctx.hideSignaturePad,
          onUploadSignature: _ctx.uploadSignature,
          showModal: _ctx.state.data.showSignaturePad,
          from: 'estimation'
        }, null, 8, ["onClose", "onUploadSignature", "showModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignatureUpload)
      ? (_openBlock(), _createBlock(_component_SignatureUploadModal, {
          key: 1,
          showModal: _ctx.state.data.showSignatureUpload,
          signatureFile: _ctx.state.data.uploadSignatureFile,
          from: 'estimation',
          onClose: _ctx.hideSignatureUpload,
          onUploadSignature: _ctx.uploadSignature
        }, null, 8, ["showModal", "signatureFile", "onClose", "onUploadSignature"]))
      : _createCommentVNode("", true)
  ], 64))
}